// extracted by mini-css-extract-plugin
export default {"container":"Theme_container__IbmUE","box":"Theme_box__nfQ1y"};